<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">
        {{ viewOnly ? "Ver conductor" : editing ? "Editar conductor" : "Nuevo conductor" }}
      </h1>
    </div>
    <div>
      <form class="custom-form" @submit.prevent="save" novalidate>
        <b-card tag="article" no-body style="max-width: 760px" class="custom-card">
          <b-card-header header-tag="section" class="custom-card-header d-flex align-items-center">
            <h3>
              {{ viewOnly ? "Datos del conductor" : editing ? "Datos del usuario" : "Datos del nuevo usuario" }}
            </h3>
          </b-card-header>
          <b-card-body class="custom-card-body p-0">
            <section class="form-section">
              <div>
                <h2 class="form-subtitle">Información general</h2>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="identifier_type">Tipo de documento * </label>
                    <FormSelect id="identifier_type" v-model="form.identifier_type" :items="identifierTypes"
                      defaultOption="Elegir tipo de documento" :disabled="viewOnly" :showError="$v.form.identifier_type.$error &&
                        !$v.form.identifier_type.required
                        " />
                    <FormError v-if="
                      $v.form.identifier_type.$error &&
                      !$v.form.identifier_type.required
                    " message="Tipo de documento es requerido" />
                  </div>
                </div>

                <div class="form-group">
                  <label for="identifier_number">Número de documento *</label>
                  <input id="identifier_number" type="text" :maxlength="maxLengthIdentifier"
                    v-model.trim="form.identifier_number" autocomplete="off" placeholder="Ingresar número de documento"
                    :disabled="viewOnly" class="custom-form-control" :class="{
                      'custom-form-control-error': $v.form.identifier_number.$error,
                    }" />
                  <FormError v-if="
                    $v.form.identifier_number.$error && !$v.form.identifier_number.required
                  " message="Número de documento es requerido" />
                  <FormError v-if="$v.form.identifier_number.$dirty && !$v.form.identifier_number.validDNI"
                    message="El DNI debe tener exactamente 8 dígitos" />
                </div>

                <div class="col-md-12">
                  <div class="form-group">
                    <label for="full_name">Nombre completo *</label>
                    <input id="full_name" type="text" v-model="form.full_name" autocomplete="off"
                      placeholder="Ingresar nombres" :disabled="viewOnly" class="custom-form-control" :class="{
                        'custom-form-control-error': $v.form.full_name.$error,
                      }" />
                    <FormError v-if="$v.form.full_name.$error && !$v.form.full_name.required"
                      message="Nombre completo es requeridos" />
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group">
                    <label for="email">Correo electrónico</label>
                    <input id="email" type="email" v-model.trim="form.email" autocomplete="off"
                      placeholder="Ingresar correo electrónico" :disabled="viewOnly" class="custom-form-control" :class="{
                        'custom-form-control-error': $v.form.email.$error,
                      }" />
                    <FormError v-if="$v.form.email.$error && !$v.form.email.email"
                      message="Correo electrónico no tiene un formato válido" />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="license_number">Número de licencia de conducir *</label>
                    <input id="license_number" type="text" v-model.trim="form.license_number" autocomplete="off"
                      placeholder="Ingresar número de licencia de conducir" :disabled="viewOnly" class="custom-form-control" :class="{
                        'custom-form-control-error':
                          $v.form.license_number.$error,
                      }" />
                    <FormError v-if="
                      $v.form.license_number.$error &&
                      !$v.form.license_number.required
                    " message="Número de licencia de conducir es requerido" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="phone_number">Celular personal *</label>
                    <input id="phone_number" type="text" v-model.trim="form.phone_number" autocomplete="off"
                      placeholder="Ingresar número de celular" maxlength="9" :disabled="viewOnly" class="custom-form-control" :class="{
                        'custom-form-control-error': $v.form.phone_number.$error,
                      }" @keypress="(e) => { if (!/[0-9]/.test(e.key)) e.preventDefault() }" />
                    <FormError v-if="$v.form.phone_number.$error && !$v.form.phone_number.required"
                      message="El celular es obligatorio" />
                    <FormError v-if="$v.form.phone_number.$error && !$v.form.phone_number.numeric"
                      message="Número de teléfono debe ser un valor numérico" />
                    <FormError message="Ingresa un número de teléfono válido de 9 dígitos"
                      v-if="$v.form.phone_number.$error && !$v.form.phone_number.phone_number"></FormError>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-0">
                    <label for="license_type">Tipo de licencia * </label>
                    <FormSelect id="license_type" v-model="form.license_type" :items="licenseTypes"
                      defaultOption="Elegir tipo de licencia" :disabled="viewOnly" :showError="$v.form.license_type.$error &&
                        !$v.form.license_type.required
                        " />
                    <FormError v-if="
                      $v.form.license_type.$error &&
                      !$v.form.license_type.required
                    " message="Tipo de licencia es requerido" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-0">
                    <label for="insurance_policy_number">Póliza de seguro *</label>
                    <input id="insurance_policy_number" type="text" v-model="form.insurance_policy_number"
                      autocomplete="off" placeholder="Ingresar póliza de seguro" :disabled="viewOnly" class="custom-form-control" :class="{
                        'custom-form-control-error':
                          $v.form.insurance_policy_number.$error,
                      }" />
                    <FormError v-if="
                      $v.form.insurance_policy_number.$error &&
                      !$v.form.insurance_policy_number.required
                    " message="Póliza de seguro es requerida" />
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group-buttons text-right">
                    <router-link :to="{ name: 'config-driver-list' }" class="button button-light">
                      {{ editing || viewOnly ? "Volver" : "Cancelar" }}
                    </router-link>
                    <button v-if="!viewOnly" class="button button-primary" type="submit">
                      Guardar
                    </button>
                  </div>
                </div>
              </div>
            </section>
          </b-card-body>
        </b-card>
      </form>
    </div>
  </div>
</template>

<script>
import { Alert, FormSelect, FormError, CustomValidators } from "wize-admin";

import { DriverService } from "@/core/services";
import { Constants as LocalConstants } from "@/core/utils";
import { required, numeric, email } from "vuelidate/lib/validators";

export default {
  components: {
    FormError,
    FormSelect,
  },
  data() {
    return {
      profileTypes: [
        LocalConstants.ProfileTypes.ADMIN,
        LocalConstants.ProfileTypes.SUPERVISOR,
      ],
      identifierTypes: [
        LocalConstants.IdentifierType.DNI,
        LocalConstants.IdentifierType.RUC,
        LocalConstants.IdentifierType.CE,
        LocalConstants.IdentifierType.PASSPORT,
      ],
      licenseTypes: [
        LocalConstants.LicenseTypesPeru.A_I,
        LocalConstants.LicenseTypesPeru.A_IIA,
        LocalConstants.LicenseTypesPeru.A_IIB,
        LocalConstants.LicenseTypesPeru.A_IIIA,
        LocalConstants.LicenseTypesPeru.A_IIIB,
        LocalConstants.LicenseTypesPeru.A_IIIC,
        LocalConstants.LicenseTypesPeru.B_I,
        LocalConstants.LicenseTypesPeru.B_IIA,
        LocalConstants.LicenseTypesPeru.B_IIB,
        LocalConstants.LicenseTypesPeru.B_IIC,
      ],
      allProjectsSelected: false,
      form: {
        identifier_type: null,
        identifier_number: null,
        full_name: null,
        email: null,
        license_number: null,
        phone_number: null,
        license_type: null,
        insurance_policy_number: null,
      },
      editing: false,
    };
  },
  validations: {
    form: {
      identifier_type: { required },
      identifier_number: {
        required,
        validDNI(value) {
          if (!value || this.form.identifier_type !== 1) return true
          return value.length === 8
        }
      },
      full_name: { required },
      email: { email },
      license_number: { required },
      phone_number: { required, numeric, mobile: CustomValidators.mobile },
      license_type: { required },
      insurance_policy_number: { required },
    },
  },
  watch: {
    "$route.params.id": function () {
      if (this.$route.params.id) this.load(this.$route.params.id);
    },
    "form.identifier_number"() {
      this.$v.form.identifier_number.$touch();
    },
  },
  computed: {
    viewOnly() {
      return this.$route.query.view === '1';
    },
    maxLengthIdentifier: function () {
      const lengths = { 1: 8, 6: 11, 4: 20, 7: 20 }
      return lengths[this.form.identifier_type] || 20
    },
  },
  methods: {
    async save() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$nextTick(() => {
          this.$smoothScroll({
            scrollTo: document.querySelector(".form-error"),
            updateHistory: false,
            offset: -50,
          });
        });

        return;
      }

      try {
        this.$store.dispatch("app/loading", true);

        const data = {
          ...this.form,
        };

        if (!this.editing) {
          await DriverService.save(data);

          this.$router.push({
            name: "config-driver-list",
          });
        } else {
          await DriverService.update(this.$route.params.id, data);

          this.load(this.$route.params.id);

          this.editing = true;
        }

        Alert.success("Se almacenó la información correctamente");
      } catch (ex) {
        console.error(ex);
        let message = ex.errors.message;
        if (ex.errors && ex.errors.message.includes('already exists')) {
          message = 'El número de documento ya se encuentra registrado.';
        } else if (ex.errors && ex.errors.message.includes('celular')) {
          message = ex.errors.message;
        }
        Alert.error(message);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    async load(id) {
      try {
        this.$store.dispatch("app/loading", true);
        const response = await DriverService.get(id);
        const payload = response.payload;

        this.form = {
          ...payload,
        };

        this.editing = true;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
        this.$router.push({ name: "form-list" });
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
  },
  async created() {
    if (this.$route.params.id) this.load(this.$route.params.id);
  },
};
</script>

<style lang="stylus" scoped></style>